export const MS = 1
export const SEC = MS * 1000
export const MIN = SEC * 60
export const HOUR = MIN * 60

export const getHourlyTimestamp = () => Math.round(Date.now() / HOUR) * HOUR